import NewsTipsList from './NewsTipsList'
export default NewsTipsList
